import React from 'react';
import logo from '../assets/images/logo.svg';

const Logo = () => {
  return <img src={logo} alt="logo" />;
};

export default Logo;
